import { config as defaultConfig } from "../../default/Kambi/Config.resource";
import { pokerHistoryLinks } from "../../../../utils/links-utils";
import { PageContextUtils, UrlUtils } from "../../../../utils";

const getCasinoUrl = language => {
  let casinoLink;
  switch (language) {
    case "de":
    case "es":
    case "fi":
    case "fr":
      casinoLink = `https://${language}.888casino.com/`;
      break;
    case "pt":
      casinoLink = "https://br.888casino.com/";
      break;
    case "ru":
      casinoLink = "https://ru.888casino-game.com/";
      break;
    default:
      casinoLink = "https://www.888casino.com/";
      break;
  }
  return casinoLink;
};

const getSportUrl = () => {
  return UrlUtils.getCurrentOriginURLWithLang(window.location.origin);
};

const { langId } = PageContextUtils.getLocalizationData();
const { clientPage } = PageContextUtils.getSurveyData();

export const links = {
  home: "/",
  casinoUrl: getCasinoUrl(langId),
  pokerUrl: "https://www.888poker.com/openclient/",
  pokerUrlAuthenticated: "https://www.888sport.com/spt/openclient.htm",
  pokerNativeUrliOS: "https://888pis.onelink.me/XSR2/sport2poker",
  pokerNativeUrlAndroid: "https://888pis.onelink.me/XSR2/sport2pokerAPK",
  pokerNativeUrlAndroidUKandIRL: "https://888pis.onelink.me/XSR2/sport2pokerGP",
  sportUrl: getSportUrl(),
  help:
    langId?.toLowerCase() === "de"
      ? "https://888-external-de.custhelp.com/app/home/p/243/"
      : "http://www.888.com/help/app/home/p/243/",
  survey: clientPage,
  liveNowDE: "/live-wetten/",
  startingSoon: "/starting-soon/",
  contactUs: `https://888-external-${
    langId?.toLowerCase() === "de" ? langId : "en"
  }.custhelp.com/app/home/p/243/`,
  liveChat:
    "https://888-external-en.custhelp.com/app/chat/chat_launch?chanel=888sport_en_norm&ChRefId=3",
  liveChatVIP:
    "https://888-external-en.custhelp.com/app/chat/chat_launch?chanel=888sport_en_vip&ChRefId=1",
  liveChatDE:
    "https://888-external-de.custhelp.com/app/chat/chat_launch?chanel=888sport_de_norm&ChRefId=3",
  responsibleGaming:
    langId?.toLowerCase() === "en"
      ? "/responsible-gaming.htm"
      : `https://${langId}.888.com/security-and-privacy/responsible-gaming/`,
  pokerHistoryLinks,
  liveNow: "/live-betting/",
  promotions: "/online-sports-betting-promotions/",
  promotionsVIP: "/vip-sports-betting/current.htm",
  recommendations: "/recommendations/",
  madeForYou: {
    ar: "/madeforyou/fortoday/mfytoday/",
    deu: "/fursiegemacht/furheute/mfytoday/",
    en: "/madeforyou/fortoday/mfytoday/",
    es: "/disenadoparati/parahoy/mfytoday/",
    fi: "/sinuavarten/tallepaivalle/mfytoday/",
    fr: "/concupourvous/pouraujourdhui/mfytoday/",
    pt: "/feitoparavoce/parahoje/mfytoday/",
    ru: "/сделанодлявас/Насегодня/mfytoday/"
  },
  betFeed: "/betfeed/",
  bettingHistory: "/bets/b/",
  bettingRules: "/getting-started/betting-rules-new/",
  gameCare: "https://www.gamcare.org.uk/",
  beGambleAware: "https://www.gambleaware.org/"
};

export const config = {
  ...defaultConfig,
  logo_VIP: "sport_logo_VIP",
  gameHeaderIcons: []
};
